import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Room } from '../modal/room';

export interface EditRoomParams {
  fieldId: string;
  fieldName: string;
}

export const updateRoomAPI = async ({ fieldId, fieldName }: EditRoomParams) => {
  const resp = await baseAPI.patch<Room>(`/custom-form/${fieldId}`, {
    fieldName,
    fieldId,
    fieldType: 'room',
  });
  return resp.data;
};

export const useUpdateRoomMutation = () => {
  return useMutation({
    mutationFn: async (params: EditRoomParams) => {
      const response = await updateRoomAPI(params);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.ROOMS,
      });
    },
  });
};
